/**
 * Terms update acknowledgement (Got it card).
 * Bump CURRENT_TERMS_VERSION_ID when Terms roll. Copy changes alone do not reset ack.
 */

export const CURRENT_TERMS_VERSION_ID = 'terms-2026-10-09'

export const TERMS_DOCS_URL = 'https://app.wlth.xyz/docs/disclaimer/terms-and-conditions'

/** Optional deep link; in-app summary is shown in the Terms update modal. */
export const PRIMARY_CHANGES_URL =
  'https://app.wlth.xyz/docs/disclaimer/terms-and-conditions#primary-changes'

/** Shown when the user expands "here" in the Terms update acknowledgement modal. */
export const PRIMARY_CHANGES_SUMMARY = [
  'Clarified how WLTH handles custody, wallet connectivity, and on-chain transactions.',
  'Updated risk disclosures for pre-IPO and marketplace investments, including liquidity and lock-up language.',
  'Aligned privacy and communications terms with current app features (support desk, referrals, and notifications).',
] as const

export const TERMS_ACK_STORAGE_KEY = 'termsAck'

export const TERMS_UPDATE_COPY = {
  title: 'Updates to our Terms and Conditions',
  bodyBeforeTerms: "We're updating our ",
  termsLinkPhrase: 'Terms and Conditions',
  bodyAfterTerms:
    ". Now's a good time to review them. We've also summarized the primary changes ",
  hereLinkPhrase: 'here',
  bodyAfterHere: '.',
  cta: 'Got it',
  microcopy: 'Continued use means you have read and agree to the terms',
  error: "Couldn't save acknowledgement. Try again.",
  saving: 'Saving',
} as const

export type TermsAckSurface = 'pwa'

export type TermsAck = {
  versionId: string
  acknowledgedAt: string
  surface: TermsAckSurface
}
